import React, { useState } from "react";
import AiResult from "./AiResult";
import { getAuthHeaders } from "../utils/auth";
import { useLanguage } from "../utils/i18n";

const LANGUAGES = [
  "Chinese (Simplified)",
  "Chinese (Traditional)",
  "Spanish",
  "French",
  "German",
  "Japanese",
  "Korean",
  "Arabic",
  "Portuguese",
  "Russian",
  "Hindi",
  "Italian",
];

export default function TranslateTab({ book, api, showToast, onAddNote, result, onSetResult }) {
  const [startPage, setStartPage] = useState(1);
  const [endPage, setEndPage] = useState(1);
  const [language, setLanguage] = useState("Chinese (Simplified)");
  const [loading, setLoading] = useState(false);
  const { t } = useLanguage();

  const MAX_PAGES = 5;

  const handleTranslate = async () => {
    if (startPage < 1 || endPage < startPage || endPage > book.total_pages) {
      showToast(t("invalidPageRange"));
      return;
    }
    if (endPage - startPage + 1 > MAX_PAGES) {
      showToast(t("tooManyPagesTranslate"));
      return;
    }
    setLoading(true);
    try {
      const authHeaders = await getAuthHeaders();
      const res = await fetch(`${api}/translate`, {
        method: "POST",
        headers: { "Content-Type": "application/json", ...authHeaders },
        body: JSON.stringify({
          book_id: book.id,
          start_page: startPage,
          end_page: endPage,
          language,
        }),
      });
      const data = await res.json();
      if (res.ok) {
        onSetResult(data.translation);
      } else {
        showToast(data.error || t("translationFailed"));
      }
    } catch {
      showToast(t("failTranslate"));
    }
    setLoading(false);
  };

  return (
    <div className="tab-content">
      <div className="form-section">
        <label>{t("pageRangeLabel")} (1 – {book.total_pages})<span style={{ fontWeight: 400, color: "var(--text-secondary)", marginLeft: 6, fontSize: "0.8rem" }}>{t("maxPagesHint")}</span></label>
        <div className="page-range">
          <input
            type="text"
            inputMode="numeric"
            value={startPage}
            onChange={(e) => { const v = parseInt(e.target.value, 10); if (!isNaN(v)) setStartPage(v); else if (e.target.value === "") setStartPage(""); }}
            onBlur={(e) => { const v = parseInt(e.target.value, 10); const clamped = !isNaN(v) ? Math.max(1, Math.min(v, book.total_pages)) : 1; setStartPage(clamped); setEndPage((prev) => Math.min(prev, clamped + MAX_PAGES - 1)); }}
          />
          <span>{t("pageRangeTo")}</span>
          <input
            type="text"
            inputMode="numeric"
            value={endPage}
            onChange={(e) => { const v = parseInt(e.target.value, 10); if (!isNaN(v)) setEndPage(v); else if (e.target.value === "") setEndPage(""); }}
            onBlur={(e) => { const v = parseInt(e.target.value, 10); const clamped = !isNaN(v) ? Math.max(startPage, Math.min(v, book.total_pages, startPage + MAX_PAGES - 1)) : startPage; setEndPage(clamped); }}
          />
        </div>
      </div>

      <div className="form-section">
        <label>{t("targetLanguageLabel")}</label>
        <select
          className="lang-select"
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
        >
          {LANGUAGES.map((l) => (
            <option key={l} value={l}>{l}</option>
          ))}
        </select>
      </div>

      <button
        className="action-btn primary"
        onClick={handleTranslate}
        disabled={loading}
      >
        {loading ? (
          <div className="loading-dots"><span /><span /><span /></div>
        ) : (
          t("translateBtn")
        )}
      </button>

      {result && (
        <AiResult
          content={result}
          onAddNote={onAddNote ? () => onAddNote(`Translation (${language}) – Pages ${startPage}–${endPage}`, result) : null}
        />
      )}
    </div>
  );
}
